// import draggable from './module/draggable';
// import clipboard from './module/clipboard';
// import auth from './module/auth';
// import permission from './module/permission';
import dbClick from './module/dbClick';
const directives = {
  // draggable,
  // clipboard,
  // auth,
  // permission,
  dbClick,
};

export default directives;
